export enum RoutesEnum {
  HOME_PAGE = '/',
  ABOUT_PAGE = '/about',
  BLOG_PAGE = '/blog',
  CALL_PAGE = '/call',
  STORIES_PAGE = '/stories',
}
